import { ExchangeMinimumOdds } from "../../models/responses/exchangeMinimumOdds";
import localization from "../../../../config/localization";
import { ExchangeEnum } from "../../models/enums/exchangeEnum";
import { BonusConsts } from "../../models/constants/bonusConsts";

interface MinimumOddsSectionProps {
  verticalbonusname: string | null;
  isindividualminimumoddsenabled: boolean;
  exchangeminimumoddsjson: string | null;
  minimumodds: number;
}

const ShowMinimumOddsSection = () => {
  return (
    <div className="grid">
      <span className="text-[#A9A9A9] text-sm">{localization.minimumodds}</span>
      <span className="mt-2 border-t border-[#212121]"></span>
    </div>
  );
};

export default function MinimumOddsSection({
  verticalbonusname,
  isindividualminimumoddsenabled,
  exchangeminimumoddsjson,
  minimumodds,
}: MinimumOddsSectionProps) {
  const exchangeMinimumOdds: ExchangeMinimumOdds[] = exchangeminimumoddsjson
    ? JSON.parse(exchangeminimumoddsjson)
    : [];
  return (
    <>
      {minimumodds > 0 ||
      (isindividualminimumoddsenabled && exchangeMinimumOdds.length > 0)
        ? ShowMinimumOddsSection()
        : null}
      <div className="grid grid-cols-4 gap-1.5">
        {isindividualminimumoddsenabled &&
          exchangeMinimumOdds.length > 0 &&
          exchangeMinimumOdds.map((odds, index) => (
            <div
              key={index}
              className="flex flex-col items-center bg-[#1A1A1A] border border-[#353535] rounded-md px-1 py-2 min-w-0"
            >
              <span className="text-white font-medium">
                {odds.MinimumOdds.toLocaleString("en-IN", {
                  minimumFractionDigits: 1,
                  maximumFractionDigits: 1,
                })}
              </span>
              <span className="text-[#A9A9A9] text-xs mt-1 truncate w-full text-center">
                {ExchangeEnum[odds.CategoryType] ?? "-"}
              </span>
            </div>
          ))}
        {minimumodds > 0 && (
          <div className="flex flex-col items-center bg-[#1A1A1A] border border-[#353535] rounded-lg px-1 py-2 min-w-0">
            <span className="text-white text-sm font-medium">
              {minimumodds.toLocaleString("en-IN", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
              })}
            </span>
            <span className="text-[#A9A9A9] text-[10px] mt-1 truncate w-full text-center">
              {verticalbonusname?.includes(BonusConsts.SportsVertical)
                ? BonusConsts.SportsVertical
                : BonusConsts.ExchangeVertical}
            </span>
          </div>
        )}
      </div>
    </>
  );
}
